import { FetchJson } from './Fetch';

const usersAPI = {
    getUser:(data) => FetchJson.get( `/admin-users/`,data),
    getUserById:(id) => FetchJson.get( `/admin-users/${id}`),
    putUserStatus:(id,data) => FetchJson.put( `/admin-users/${id}/status`, data),
    getApplicantList:(data) => FetchJson.get( `/admin-teachers`,data),
    getInstructorById:(id) => FetchJson.get( `/admin-teachers/${id}`),
    getInstructorStatus:(data) => FetchJson.get( `/admin-teachers/status`,data),
    putInstructorInfo:(id,data) => FetchJson.put( `/admin-teachers/${id}/admin-review`,data),
    deleteInstructorById:(id) => FetchJson.delete( `/admin-teachers/${id}`),
    deleteInstructor:(data) => FetchJson.delete( `/admin-teachers?${data}`),
    putInstructorStatus:(id, data) => FetchJson.put( `/admin-teachers/${id}/status`,data),
    putInstructorProfile:(id, data) => FetchJson.put( `/admin-teachers/${id}`,data),
};

export { usersAPI };